export default "__VITE_ASSET__D3Dcz1o1__"